import React from 'react';
import { Typography, Collapse, Grid, Card } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const FAQ = ({ localeKey = 'faq' }) => {
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const items = t(`${localeKey}.questions`, { returnObjects: true }).map((faq, index) => ({
    key: index,
    label: (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        fontSize: '16px',
        fontWeight: '500',
        color: '#333'
      }}>
        {faq.question}
      </div>
    ),
    children: (
      <div style={{ 
        padding: isMobile ? '24px 20px' : '24px 24px',
        lineHeight: '1.7',
        color: '#333',
        fontSize: '16px',
        fontWeight: '400'
      }}
        dangerouslySetInnerHTML={{ __html: faq.answer }}
      />
    )
  }));

  return (
    <div style={{ 
      maxWidth: '900px', 
      margin: '0 auto',
      padding: '20px',
    }}>
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <Title
          level={2}
          style={{
            color: '#333',
            marginBottom: '12px'
          }}
        >
          {t(`${localeKey}.title`)}
        </Title>
        <Text 
          style={{ 
            fontSize: '16px', 
            color: '#666',
            lineHeight: '1.5'
          }}
        >
        </Text>
      </div>

      <Card
        style={{
          border: '1px solid #f0f0f0',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          background: 'white'
        }}
        styles={{ body: { padding: isMobile ? '16px 12px' : '16px 24px' } }}
      >
        <Collapse 
          expandIconPosition="end"
          style={{
            background: 'transparent',
            border: 'none'
          }}
          items={items}
          expandIcon={({ isActive }) => (
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              backgroundColor: isActive ? 'var(--upgrade-color)' : '#f5f5f5',
              color: isActive ? 'white' : '#666',
              fontSize: '12px',
              transition: 'all 0.2s ease',
              transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)'
            }}>
              ▼
            </div>
          )}
        />
      </Card>
    </div>
  );
};

export default FAQ;
